import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getMailTemplateById,
  getMailTemplateList,
  insertMailTemplate,
  updateMailTemplate,
} from 'services/template'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_MAIL_TEMPLATE_LIST(action) {
  try {
    const mailTemplate = yield call(getMailTemplateList, action.payload)
    if (mailTemplate.ok) {
      yield put({
        type: actions.MAIL_TEMPLATE_LIST_LOAD_SUCCEEDED,
        payload: mailTemplate.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar las plantillas de email')
      put({
        type: actions.MAIL_TEMPLATE_LIST_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.MAIL_TEMPLATE_LIST_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_MAIL_TEMPLATE_BY_ID(action) {
  try {
    const mailTemplate = yield call(getMailTemplateById, action.payload)
    if (mailTemplate.ok) {
      yield put({
        type: actions.MAIL_TEMPLATE_BY_ID_LOAD_SUCCEEDED,
        payload: mailTemplate.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar mail template')
      put({
        type: actions.MAIL_TEMPLATE_BY_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.MAIL_TEMPLATE_BY_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_MAIL_TEMPLATE(action) {
  try {
    const mailTemplate = yield call(updateMailTemplate, action.payload)
    if (mailTemplate.ok) {
      putMessage(messageType.SUCCESS, 'Mail Template modificado correctamente')
      yield put({
        type: actions.MAIL_TEMPLATE_UPDATE_SUCCEEDED,
        payload: mailTemplate.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Mail Template')
      yield put({
        type: actions.MAIL_TEMPLATE_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Mail Template')
    yield all([
      put({
        type: actions.MAIL_TEMPLATE_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_MAIL_TEMPLATE(action) {
  try {
    const mailTemplate = yield call(insertMailTemplate, action.payload)
    if (mailTemplate.ok) {
      putMessage(messageType.SUCCESS, 'Plantilla de Email creada correctamente')
      yield put({
        type: actions.MAIL_TEMPLATE_INSERT_SUCCEEDED,
        payload: mailTemplate.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear la Plantilla de Email')
      yield put({
        type: actions.MAIL_TEMPLATE_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear la Plantilla de Email')
    yield all([
      put({
        type: actions.MAIL_TEMPLATE_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.MAIL_TEMPLATE_LIST_LOAD_REQUESTED, GET_MAIL_TEMPLATE_LIST),
    takeEvery(actions.MAIL_TEMPLATE_BY_ID_LOAD_REQUESTED, GET_MAIL_TEMPLATE_BY_ID),
    takeEvery(actions.MAIL_TEMPLATE_UPDATE_REQUESTED, UPDATE_MAIL_TEMPLATE),
    takeEvery(actions.MAIL_TEMPLATE_INSERT_REQUESTED, INSERT_MAIL_TEMPLATE),
  ])
}
